export default "__VITE_ASSET__SJ$_MH2U__"